<div class="container-fluid" style="position: relative; height: 100vh; padding-left: 3rem;">
  <div class="row justify-content-center mt-5 mb-5">
    <div class="col-md-8 form position-relative">
      <div *ngIf="updating || loadingUserData || loadingCountryList"
        class="position-absolute top-50 start-50 translate-middle vstack" style="z-index:1000;">
        <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div class="loading-text">
          Loading...
        </div>
      </div>
      <form class="row g-3" [formGroup]="form"
        [ngClass]="updating || loadingUserData || loadingCountryList ? 'blur-background' : ''"
        (ngSubmit)="onClickSubmit()" novalidate>
        <div class="text-center mb-4">
          <!-- <h1 class="dashboard-sub-heading">User Details</h1> -->
        </div>
        <div class="col-md-6 text-start">
          <label for="firstName" class="form-label">Full Name</label>
          <input type="text" class="form-control" id="firstName" formControlName="fullName"
            [ngClass]="{ 'is-invalid': submitted && formControl['fullName'].errors }" [readonly]="role == 'admin'">
          <div *ngIf="submitted && formControl['fullName'].errors" class="invalid-feedback">
            <div *ngIf="formControl['fullName'].errors['required']">
              Full Name is required
            </div>
          </div>
        </div>

        <div class="col-md-6 text-start">
          <label for="email" class="form-label">Email address</label>
          <input type="text" class="form-control" id="email" formControlName="email"
            [ngClass]="{ 'is-invalid': submitted && formControl['email'].errors }" [readonly]="true">
          <div *ngIf="submitted && formControl['email'].errors" class="invalid-feedback">
            <div *ngIf="formControl['email'].errors['required']">
              Email is required
            </div>
            <div *ngIf="formControl['email'].errors['email']">
              Email is not valid
            </div>
          </div>
        </div>
        <div class="col-md-6 text-start">
          <label for="contactNo" class="form-label">Phone Number</label>
          <div class="d-flex">
            <ngx-intl-tel-input *ngIf="allowedCountryCodes.length > 0" type="text" id="contactNo"
              formControlName="contactNo" [ngClass]="{ 'is-invalid': submitted && formControl['contactNo'].errors }"
              [enablePlaceholder]="true" [searchCountryFlag]="true" [selectFirstCountry]="true"
              [separateDialCode]="true" [maxLength]="15" [phoneValidation]="true" [disabled]="role=='admin'"
              [enableAutoCountrySelect]="true" [onlyCountries]="allowedCountryCodes"></ngx-intl-tel-input>
            <div class="sl-flex-row" id="contactNum">
              <input type="tel" class="form-control" id="contactNumber" formControlName="contactNumber"
                [ngClass]="{ 'is-invalid': submitted && formControl['contactNumber'].errors }"
                [readonly]="role == 'admin'">

            </div>
          </div>

        </div>

        <div class="col-md-6 text-start">
          <label for="company" class="form-label">Company</label>
          <input type="text" class="form-control" id="company" formControlName="company"
            [ngClass]="{ 'is-invalid': submitted && formControl['company'].errors }" [readonly]="true">
          <div *ngIf="submitted && formControl['company'].errors" class="invalid-feedback">
            <div *ngIf="formControl['company'].errors['required']">
              Company is required
            </div>
          </div>
        </div>
        <div class="col-md-6 text-start" *ngIf="!(role == 'admin')">
          <label for="country" class="form-label">Country</label>
          <select id="country" class="form-select" aria-label="country" formControlName="country" size='1'
            onfocus='if (this.options.length > 5){this.size = 5}' onblur="this.size = 1"
            onchange='this.size = 1;  this.blur();'
            [ngClass]="{ 'is-invalid': submitted && formControl['country'].errors }">
            <option *ngFor="let country of countryList" [ngValue]="country.countryId" disabled>{{country.countryName}}
            </option>
          </select>
          <div *ngIf="submitted && formControl['country'].errors" class="invalid-feedback">
            <div *ngIf="formControl['country'].errors['required']">
              Country is required
            </div>
          </div>
        </div>
        <div class="col-md-6 text-start">
          <label for="username" class="form-label">Username</label>
          <input type="text" class="form-control" id="username" formControlName="username"
            [ngClass]="{ 'is-invalid': submitted && formControl['username'].errors }" [readonly]="true">
          <div *ngIf="submitted && formControl['username'].errors" class="invalid-feedback">
            <div *ngIf="formControl['username'].errors['required']">
              Username is required
            </div>
          </div>
        </div>
        <div class="col-md-6 text-start" *ngIf="!(role == 'admin')">
          <label for="institution" class="form-label">Institution</label>
          <input type="text" class="form-control" id="institution" formControlName="institution"
            [ngClass]="{ 'is-invalid': submitted && formControl['institution'].errors }" [readonly]="true">
          <div *ngIf="submitted && formControl['institution'].errors" class="invalid-feedback">
            <div *ngIf="formControl['institution'].errors['required']">
              Institution is required
            </div>
          </div>
        </div>
        <div class="col-md-6 text-start" *ngIf="!(role == 'admin')">
          <label for="region" class="form-label">Region</label>
          <input type="text" class="form-control" id="region" formControlName="region"
            [ngClass]="{ 'is-invalid': submitted && formControl['region'].errors }" [readonly]="true">
          <div *ngIf="submitted && formControl['region'].errors" class="invalid-feedback">
            <div *ngIf="formControl['region'].errors['required']">
              Region selection is required
            </div>
          </div>
        </div>

        <!--        <div class="col-6 mb-3 text-start" *ngIf="!(role == 'admin')">-->
        <!--          <h6>Preferred APIs</h6>-->
        <!--&lt;!&ndash;          <p class="text-muted">{{apis}}</p>&ndash;&gt;-->
        <!--          <div class="form-label add-form-checkBox" style="padding: 10px">-->
        <!--            <input type="checkbox" id="FintechApiEnableCheck" ng-model="check" formControlName="openAPIEnabled" />-->
        <!--            Fintech API enable-->
        <!--          </div>-->
        <!--          <div class="form-label add-form-checkBox" style="padding: 10px">-->
        <!--            <input type="checkbox" id="FixApiEnableCheck" ng-model="check" formControlName="fixAPIEnabled" />-->
        <!--            Fix API enable-->
        <!--          </div>-->
        <!--          <div class="form-label add-form-checkBox" style="padding: 10px">-->
        <!--            <input type="checkbox" id="AccountApiEnableCheck" ng-model="check"-->
        <!--                   formControlName="backOfficeAPIEnabled" />-->
        <!--            Backoffice API enable-->
        <!--          </div>-->
        <!--          <div class="form-label add-form-checkBox" style="padding: 10px">-->
        <!--            <input type="checkbox" id="DwmEnableCheck" ng-model="check" formControlName="dwmAPIEnabled"/>-->
        <!--            DWM enable-->
        <!--          </div>-->
        <!--          <div class="form-label add-form-checkBox" style="padding: 10px">-->
        <!--            <input type="checkbox" id="FeedApiEnableCheck" ng-model="check"-->
        <!--                   formControlName="feedAPIEnabled" />-->
        <!--            Feed API enable-->
        <!--          </div>-->
        <!--        </div>-->


        <div class="col-12 mb-3 text-start" *ngIf="!(role == 'admin')">
          <h6>Preferred APIs</h6>
          <div class="d-flex flex-wrap gap-3">
            <label class="form-label add-form-checkBox d-flex align-items-center gap-2">
              <input type="checkbox" id="FintechApiEnableCheck" formControlName="openAPIEnabled" [disabled]="true" />
              GTN Fintech APIs
            </label>

            <label class="form-label add-form-checkBox d-flex align-items-center gap-2">
              <input type="checkbox" id="EmbedApiEnableCheck" formControlName="embedAPIEnabled" [disabled]="true" />
              GTN Embed APIs
            </label>

            <label class="form-label add-form-checkBox d-flex align-items-center gap-2">
              <input type="checkbox" id="AccountApiEnableCheck" formControlName="backOfficeAPIEnabled"
                [disabled]="true" />
              GTN Backoffice APIs
            </label>

            <label class="form-label add-form-checkBox d-flex align-items-center gap-2">
              <input type="checkbox" id="DwmEnableCheck" formControlName="dwmAPIEnabled" [disabled]="true" />
              GTN DWM APIs
            </label>

            <label class="form-label add-form-checkBox d-flex align-items-center gap-2">
              <input type="checkbox" id="FeedApiEnableCheck" formControlName="feedAPIEnabled" [disabled]="true" />
              GTN Market Data APIs
            </label>
          </div>
        </div>


        <div class="d-flex justify-content-end" *ngIf="!(role == 'admin')">
          <button type="button" class="btn btn-primary mt-4" type="submit">
            <div *ngIf="updating" class="spinner-border spinner-border-sm text-light" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p *ngIf="!updating">
              Save Changes
            </p>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>